import { render, staticRenderFns } from "./Front-Footer.vue?vue&type=template&id=5e2f70e7&"
import script from "./Front-Footer.vue?vue&type=script&lang=js&"
export * from "./Front-Footer.vue?vue&type=script&lang=js&"
import style0 from "./Front-Footer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports